import { toast, Toaster as SonnerToaster } from 'sonner'

interface ToasterProps {
  position?:
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right'
    | 'top-center'
    | 'bottom-center'
  richColors?: boolean
  closeButton?: boolean
  duration?: number
  theme?: 'light' | 'dark' | 'system'
}

export function Toaster({
  position = 'bottom-right',
  richColors = true,
  closeButton = true,
  duration = 4000,
  theme = 'system',
}: ToasterProps) {
  return (
    <SonnerToaster
      closeButton={closeButton}
      duration={duration}
      position={position}
      richColors={richColors}
      theme={theme}
      //   toastOptions={{
      //     style: {
      //       background: 'hsl(var(--background))',
      //       color: 'hsl(var(--foreground))',
      //       border: '1px solid hsl(var(--border))',
      //       borderRadius: '8px',
      //       fontSize: '14px',
      //       fontWeight: '500',
      //     },
      //     className: 'dark:bg-gray-900 dark:text-gray-100 dark:border-gray-700',
      //   }}
    />
  )
}

// Export toast functions for convenience
export { toast }

// Custom toast functions with predefined styles
export const showSuccess = (message: string, options?: any) => {
  return toast.success(message, {
    duration: 4000,
    ...options,
  })
}

export const showError = (message: string, options?: any) => {
  return toast.error(message, {
    duration: 5000,
    ...options,
  })
}

export const showWarning = (message: string, options?: any) => {
  return toast.warning(message, {
    duration: 4000,
    ...options,
  })
}

export const showInfo = (message: string, options?: any) => {
  return toast.info(message, {
    duration: 3000,
    ...options,
  })
}

export const showLoading = (message: string, options?: any) => {
  return toast.loading(message, {
    duration: Infinity,
    ...options,
  })
}
